<template>
  <div style="width: 100%;">
    <v-container>
      <v-row>
        <v-col class='d-flex flex-row align-center'>
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          <h1>{{this.singular}}: {{this.data.name}}</h1>
          <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
            style="margin-left: 10px;"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn v-if="isAllowed('productAttribute','u')" @click="isEditable = !isEditable">
            <span v-if="this.isEditable">Cancel</span>
            <span v-else>Edit</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-form :disabled="!isEditable">
        <v-row>
          <v-col>
            <v-text-field
                label="Name"
                outlined
                v-model="data.name"
            />
            <v-text-field
                label="Slug"
                outlined
                v-model="data.slug"
                persistent-hint
                hint="Spaces within the Slug will be replaced with '-' automatically."
            />
            <v-select
                item-text="name"
                item-value="value"
                :items="typeValues"
                label="Type"
                outlined
                v-model="data.type"
            />
            <v-select
                item-text="name"
                item-value="value"
                :items="orderByValues"
                label="Order By"
                outlined
                v-model="data.orderBy"
            />
          </v-col>
        </v-row>
      </v-form>
      <v-row>
        <v-col v-if="isEditable">
          <v-btn @click="update">Save</v-btn>
          <v-btn v-if="isAllowed('productAttribute','d')" style="margin-left: 10px;" class="error" @click="deleteData">Delete</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <hr>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="isAllowed('productAttributeTerm','c')" cols="4">
          <v-container>
            <v-row>
              <v-col class='d-flex flex-row align-center'>
                <h1>Add New {{this.singular2}}</h1>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                    label="Name"
                    outlined
                    v-model="term.name"
                />
                <v-text-field
                    label="Slug"
                    outlined
                    v-model="term.slug"
                    persistent-hint
                    hint="Spaces within the Slug will be replaced with '-' automatically."
                />
                <v-text-field
                    label="Description"
                    outlined
                    v-model="term.description"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn @click="create" :disabled="!this.term.name">Create</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col>
          <v-container>
            <v-row>
              <v-col class="d-flex flex-row align-center">
                <h1>Product Attribute Terms</h1>
                <v-progress-circular
                    indeterminate
                    color="green"
                    v-if="loader"
                    style="margin-left: 10px;"
                ></v-progress-circular>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-data-table
                    :headers="secondaryHeaders"
                    :items="data.ProductAttributeTerms"
                    :items-per-page="-1"
                    class="elevation-1"
                    @click:row="secondaryRowClick"
                >
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  import axios from 'axios';
  import {mapGetters} from "vuex";
  export default {
    data () {
      return {
        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,

        snackObj: {
          state: false,
          color: '',
          text: ''
        },

        max25chars: v => v.length <= 25 || 'Input too long!',
        editMode: false,
        data: {},
        term: {
          menu_order: 0
        },
        orderByValues: [
          {name: "Menu Order", value: "menu_order"}, {name: "Name", value: "name"}, {name: "Numeric Name", value: "name_num"}, {name: "ID", value: "id"}
        ],
        typeValues: [
          {name: "Select", value: "select"}
        ],
        secondaryHeaders: [
          {
            text: 'Name',
            align: 'start',
            sortable: true,
            value: 'name',
          },
          { text: "Slug", value: 'slug'},
          { text: "Description", value: 'description'},
          { text: "Count", value: 'count'}
        ],
        singular: "Product Attribute",
        singularLower: "productattribute",
        plural: "Product Attributes",
        pluralLower: "productattributes",
        singular2: "Product Attribute Term",
        singularLower2: "productattributeterm",
        plural2: "Product Attribute Terms",
        pluralLower2: "productattributeterms",
        isEditable: false,
      }
    },
    async mounted(){
        await this.getAllData();
    },
    computed: {
      ...mapGetters(['getEndpoint', "isAllowed"])
    },
    methods: {
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.state = true;
        this.snackObj.color = color;
      },
      async update(){
        try {
          this.isEditable = false;
          this.loader = true;
          let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`, this.data)
          if(res.data.error) throw res.data.error
          if(res.data.success){
            this.snack(`${this.singular} Updated 🎉`, "success");
            this.isEditable = false;
          }
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
      },
      async deleteData(){
        try {
          this.loader = true
          let res = await axios.delete(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
          if(res.data.error) throw res.data.error

          this.snack(`${this.singular} Created 🎉`, "success");
          await this.$router.push({ path: `/${this.pluralLower}`});
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
      },
      secondaryRowClick(term){
        this.$router.push({ path: `/${this.pluralLower}/view/${this.$route.params.id}/terms/view/${term.id}`})
      },
      async create(){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower2}`, this.term)
          if(res.data.error) throw res.data.error

          this.snack(`${this.singular2} Created 🎉`);
          this.term={};
          await this.getAllData();
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error, "error");
        }
      },
      async getAllData(){
        try {
          let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
          if(res.data.error) throw res.data.error

          this.data = res.data.data;
          this.term.productAttributeId = this.data.id;
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
      }
    }
  }
</script>
